<template>

  <header class="section-header">
    <div class="top">
      <div class="container">
        <div class="logos">
          <a href="https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1" target="_blank" class="tvnorge" data-name="TVNorge">
            <img src="@/assets/tv-norge-w.svg">
          </a>
          <a href="https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1" target="_blank" class="max" data-name="Max">
            <img src="@/assets/max.svg">
          </a>
        </div>
        <div class="countdown">
          <ExpanderCountdown :date="date" />
        </div>
      </div>
    </div>
    <div class="date" :class="{small: (this.version == 'week1')}">
      <p>
        {{ phrase }}
      </p>
    </div>
  </header>

  <div class="mobile-countdown">
    <ExpanderCountdown :date="date" />
  </div>

  <div class="bg">

    <div class="tt">
      <img src="@/assets/tt.png">
    </div>

    <section class="section-videos">
      <DiscoveryVideos />
    </section>

  </div>

  <section class="section-main">
    <h1 class="heading">Klikk på rosetten for å lese mer om hedersgjestene</h1>
    <ExpanderMarquee />
  </section>

  <footer class="section-footer">
    <div class="container">
      <div class="logos">
        <a href="https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1" target="_blank" class="tvnorge" data-name="TVNorge">
          <img src="@/assets/tv-norge-w.svg">
        </a> 
        <a href="https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1" target="_blank" class="max" data-name="Max">
          <img src="@/assets/max.svg">
        </a> 
      </div>
    </div>
  </footer>


</template>

<script>
  import ExpanderCountdown from './components/ExpanderCountdown.vue';
  import DiscoveryVideos from './components/DiscoveryVideos.vue';
  import ExpanderMarquee from './components/ExpanderMarquee.vue';

  export default {
    name: 'App',
    components: {
      ExpanderCountdown,
      DiscoveryVideos,
      ExpanderMarquee,
    },
    data() {
      return {
        date: '2025-02-04T21:30:00',
      }
    },
    methods: {
      track(label, category) {
        category = category || 'Click'
        window.customTrack(category, 'interaction', label)
      },
    },
    computed: {
      phrase() {
        if (this.version === 'week1')
          return 'Premiere tirsdag 4. Februar på TVNorge'
        if (this.version === 'week2')
          return 'Premiere tirsdag 21.30 på TVNorge'
        return 'Premiere i kveld 21.30 på TVNorge'
      },
      version() {
        var theDate = new Date(this.date)
        var today = new Date()
        var weekBefore = new Date('2025-01-29T00:00:00')
        if(theDate.setHours(0,0,0,0) <= today.setHours(0,0,0,0))
          return 'today'
        if(weekBefore <= today)
          return 'week2'
        else
          return 'week1'
      }
    },
  }
</script>

<style lang="scss">
  @import "node_modules/minireset.css/minireset";
  @import '@/scss/fonts.scss';
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  :root {
    --header-height: 10.125rem;
    @include d {
      --header-height: 10rem;
    }
  }

  html {
    font-family: $font, sans-serif;
    font-size: 16px;
    // font-size: 1.48vw;
    font-weight: $weight;
    color: $color-text;
    text-align: left;
    line-height: 1.3;
    @include desktop {
      font-size: 1.48vw;
    }
    @media (min-width: $width) {
      font-size: 16px;
    }
  }
  #app {
    position: relative;
    width: $width;
    max-width: 100%;
    margin: 0 auto;
    background: $color-bg;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-top: var(--header-height);
  }

  img,
  picture,
  video {
    display: block;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  p {
    font-size: 1rem;
  }
  button {
    font-family: $font;
    font-size: 1rem;
    padding: 0;
    border: 0;
    background: none;
    outline: 0 none;
    cursor: pointer;
  }

</style>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .section-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 10000;
    .top {
      background: #E1143C;
      .container {
        width: 100%;
        max-width: $width;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 2.625rem;
        @include m {
          justify-content: center;
          padding: 1rem 1rem 1rem 1.5rem;
        }
      }
    }
    .logos {
      display: flex;
      align-items: center;
      .tvnorge {
        margin-right: 1.5rem;
        img {
          width: 5.8125rem;
        }
      }
      .max {
        img {
          width: 5.8125rem;
        }
      }
    }
    .countdown {
      @include m {
        display: none;
      }
    }
    .date {
      width: 100%;
      height: 2.5rem;
      padding: .25rem 0;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      text-transform: uppercase;
      background: #BC9C64;
      p {
        font-size: 1.5rem;
      }
      &.small {
        p {
          font-size: 1.25rem;
        }
      }
    }
  }

  .mobile-countdown {
    display: none;
    @include m {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: var(--header-height);
      z-index: 100;
      width: 100%;
      height: 5rem;
      background: rgba(188, 156, 100, 0.38);
    }
  }

  .bg {
    background: url('@/assets/bg.jpg') no-repeat center top / cover;
  }

  .tt {
    padding: 6.5rem 1rem 1.625rem;
    @include d {
      padding: 2.875rem 1rem 3.1875rem;
    }
    img {
      width: 9.375rem;
      margin: 0 auto;
      @include d {
        width: 17rem;
      }
    }
  }

  .section-main {
    padding: 2.25rem 0 2rem;
    background: url('@/assets/bg2.jpg') no-repeat center top / 800px auto;
    @include d {
      padding: 2.25rem 0 3.75rem;
      background-position: center center;
      background-size: cover;
    }
    .heading {
      max-width: 16.5rem;
      margin: 0 auto;
      font-size: 1.5rem;
      text-align: center;
      @include d {
        max-width: none;
        font-size: 2.25rem;
        margin: 0 1rem 1.3125rem;
      }
    }
  }

  .section-footer {
    background: $color-2;
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 5.75rem;
      padding: 0 2.5rem;
    }
    .logos {
      display: flex;
      align-items: center;
      .tvnorge {
        margin-right: 1.5rem;
        img {
          width: 3.5rem;
        }
      }
      .max {
        img {
          width: 4.25rem;
        }
      }
    }
  }

</style>
